<div
  class="table-heading-options"
  [ngClass]="{ 'table-heading-options--kpi-expanded': variant === 'kpi-expanded' }"
>
  <button
    type="button"
    class="filters-btn"
    [ngClass]="{
      'filters-btn--kpi-expanded': variant === 'kpi-expanded',
      'filters-btn--kpi-expanded-active': variant === 'kpi-expanded' && totalFiltersApplied > 0
    }"
    (click)="onToggle($event)"
  >
    <mat-icon
      *ngIf="variant === 'kpi-expanded'"
      svgIcon="funnel"
      class="filters-btn-funnel-icon"
    ></mat-icon>
    <span class="filters-btn-label">{{ label }}</span>
    <span *ngIf="showBadge" class="filters-btn-badge">{{ count }}</span>
    <span *ngIf="variant === 'kpi-expanded'" class="filters-btn-chevron" [class.open]="showMenu">
      <mat-icon svgIcon="caret-down"></mat-icon>
    </span>
  </button>

  <div *ngIf="showMenu" class="header-menu" (click)="onMenuClick($event)">
    <div *ngIf="totalFiltersApplied === 0" class="header-menu-empty">
      <p class="header-menu-empty-text">
        <span class="header-menu-empty-title">No filters applied.</span>
        <span class="header-menu-empty-description">
          To apply a filter, select an item in a chart or use the menu in table's column headers.
        </span>
      </p>
    </div>

    <div *ngIf="totalFiltersApplied > 0" class="header-menu-content">
      <ng-container *ngFor="let filterColumn of filtersAppliedArray; trackBy: trackByKey">
        <p class="header-menu-title-filter">
          {{ columnTitleMappings[filterColumn.key] || filterColumn.key }}
        </p>

        <ng-container *ngFor="let filter of filterColumn.value; trackBy: trackByFilter">
          <div class="header-menu-item-filter">
            <div class="header-menu-item-label">{{ filter }}</div>

            <button type="button" (click)="removeFilter(filter, filterColumn.key)">
              <mat-icon svgIcon="close" class="header-cross-icon"></mat-icon>
            </button>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="header-menu-footer">
      <p>
        {{ totalFiltersApplied === 0 ? '0 filters applied' : totalFiltersApplied + ' applied' }}
      </p>

      <div class="header-menu-footer-actions">
        <button
          type="button"
          [class.disabled]="totalFiltersApplied === 0"
          (click)="clearAllFilters()"
        >
          Clear All
        </button>
      </div>
    </div>
  </div>
</div>
